class InfiniteCollection {
  constructor() {
    this.section = document.querySelector('[data-infinite-collection]');
    if (!this.section) return;

    this.nextUrlEl = this.section.querySelector('[data-next-url]');
    this.grid = this.section.querySelector('[data-product-grid]');
    this.sentinel = this.section.querySelector('[data-infinite-sentinel]');
    if (!this.nextUrlEl || !this.grid || !this.sentinel) return;

    this.loading = false;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) this.loadMore();
    }, { rootMargin: '400px' });

    this.observer.observe(this.sentinel);
  }

  async loadMore() {
    const nextUrl = this.nextUrlEl.getAttribute('data-next-url');
    if (!nextUrl || this.loading) return;

    this.loading = true;

    try {
      // Use section rendering API so we only fetch the grid chunk
      const sectionId = this.section.getAttribute('data-section-id');
      const url = `${nextUrl}${nextUrl.includes('?') ? '&' : '?'}section_id=${sectionId}`;
      const res = await fetch(url);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-product-grid]');
      const newNext = doc.querySelector('[data-next-url]');

      if (newGrid) {
        this.grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      if (newNext && newNext.getAttribute('data-next-url')) {
        this.nextUrlEl.setAttribute('data-next-url', newNext.getAttribute('data-next-url'));
      } else {
        // No more pages
        this.observer.disconnect();
        this.sentinel.remove();
      }
    } catch (e) {
      console.error('Infinite scroll failed:', e);
    } finally {
      this.loading = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new InfiniteCollection());
document.addEventListener('shopify:section:load', () => new InfiniteCollection());